import React from 'react';
import { FieldDiamond } from './FieldDiamond';
type Tome = {
  number: string;
  title: string;
  promise: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Day One to Game One',
  promise: 'The practice engine and your first weeks — so day one runs like you’ve done it before.',
  badge: 'bg-green',
  contents: ['The No-Standing-Around Flow for every practice', 'The Catch Ladder: throwing and catching that holds up', 'The 5-Minute Reset when practice goes sideways', 'Your first weeks laid out, practice by practice', 'Ready-to-run practices, drill cards and worksheets']
}, {
  number: '02',
  title: 'Fielding That Holds Up',
  promise: 'Infield and outfield defense built on reads, not just reps.',
  badge: 'bg-clay',
  contents: ['The Funnel-and-Fire Form for clean fielding', 'The Three-Hop Read for judging the ball', 'The Four-Corner Infield Circuit (no dead time)', 'Outfield routes, drops and communication', 'Timed practice sheets for every session']
}, {
  number: '03',
  title: 'Hitting Every Kid Can Build',
  promise: 'A swing any kid can own — and a lot of good swings each practice.',
  badge: 'bg-gold-deep',
  contents: ['The Load-and-Launch Checklist for the swing', 'The Tee-to-Live Progression, step by step', 'The 20-Swings Rule so everyone gets real reps', 'Fixes for the most common swing problems', 'Station plans that keep the whole team hitting']
}, {
  number: '04',
  title: 'Baserunning, Smart and Aggressive',
  promise: 'Running the bases and reading the play, the right way.',
  badge: 'bg-green-deep',
  contents: ['The Four-Base Footwork Map', 'The Green-Light Read: when to go, when to hold', 'The Pickle Protocol for rundowns', 'Offensive situations the kids will actually face', 'Drills that make baserunning competitive and fun']
}, {
  number: '05',
  title: 'Game Situations & Team Defense',
  promise: 'Cutoffs, simple safe pitching and catching, and a scrimmage that teaches.',
  badge: 'bg-navy-line',
  contents: ['The Cutoff Compass for team defense', 'The Arm-Care Guardrail: pitch counts, done safely', 'The Situation Freeze to teach decisions live', 'Simple, safe pitching and catching basics', 'A scrimmage format that actually builds skills']
}, {
  number: '06',
  title: 'The Season Toolkit',
  promise: 'Any day, any weather, any number of kids — plus the whole-season map.',
  badge: 'bg-clay-deep',
  contents: ['The Plan-B Practice Builder for rainouts & low turnout', 'The Season Map: the whole season, sequenced', 'The Game-Day Script from warm-up to final out', 'What to run with 6 kids or 16', 'The capstone that ties all six volumes together']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-ice" data-id="element-248" data-mp="wlywiryvtcq4">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-249" data-mp="11ksbkotthbse">
        <div className="text-center" data-id="element-250" data-mp="16koh4si5xba2">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-251" data-mp="16lpsyz7061su">
            The complete season
          </p>
          <h2 id="tomes-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-252" data-mp="1algp7ifata4r">
            Inside the pack — six volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-253" data-mp="mwxhb405uzd7">
          {tomes.map(tome => <article key={tome.number} className="clip-corner flex flex-col overflow-hidden rounded-2xl border border-ice-dark bg-white shadow-card" data-id="element-254" data-mp="rnxgkfwr5tiv">
              {/* Scoreboard header band, color-coded by block (like the tomos) */}
              <div className={`relative overflow-hidden ${tome.badge}`} data-id="element-255" data-mp="3c7vkysuorq74">
                <FieldDiamond className="pointer-events-none absolute -right-5 -top-6 h-24 w-24 text-white/15" data-id="element-256" data-mp="3c85c4jrgw3ee" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-257" data-mp="376y4qlt8l689">
                  <span className="font-display text-xs font-bold uppercase tracking-[2px] text-white/85" data-id="element-258" data-mp="3lzrwb5ls9cta">
                    Volume {tome.number}
                  </span>
                  <span className="font-display text-3xl leading-none text-white" data-id="element-259" data-mp="3ux26soqs0xx5">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-6 pt-5" data-id="element-260" data-mp="8rezvn5aku49">
                <h3 className="text-lg font-bold leading-snug text-ink" data-id="element-261" data-mp="3s2gjcdmq56f">
                  {tome.title}
                </h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-262" data-mp="2ai0bx951ridq">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-ice-dark pt-4" data-id="element-263" data-mp="25jfa55a5cqn6">
                  {tome.contents.map(item => <li key={item} className="flex gap-2.5 text-[13px] text-ink" data-id="element-264" data-mp="l14sjh4av8nl">
                      <span className="mt-[6px] h-2 w-2 flex-none rotate-45 rounded-[1px] bg-gold" data-id="element-265" data-mp="q0zh3e0lrm5h" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}